import { render, staticRenderFns } from "./Searchdata.vue?vue&type=template&id=570f99a1&scoped=true&"
import script from "./Searchdata.vue?vue&type=script&lang=js&"
export * from "./Searchdata.vue?vue&type=script&lang=js&"
import style0 from "./Searchdata.vue?vue&type=style&index=0&id=570f99a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f99a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VList,VListItem,VListItemTitle,VMenu,VRow})
